export default String.raw`
{% assign productNumber = include -%}
{% assign i = productNumber | Minus:1 -%}

{% if page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' -%}
	{% assign order = customer-profile.Offer -%}
	{% assign orderString = customer-profile.OfferQueryGET -%}
{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id -%}
	{% assign order = customer-profile.Order -%}
	{% assign orderString = customer-profile.OrderQueryGET -%}
{% endif -%}

{% assign productsSize = order.Products | Size -%}
{% assign product = order.Products[i] -%}

{% assign price = product.Price -%}
{% assign productValue = product.Value -%}
{% assign priceBefore = product.ValueBeforeDiscount -%}

{% if config.ENTERPRISE -%}
	{% assign price = product.SubtotalPrice -%}
	{% assign productValue = product.SubtotalValue -%}
  	{% assign priceBefore = product.SubtotalValueBeforeDiscount -%}
  	{% assign totalPrice = product.TotalPrice -%}
  	{% assign totalValue = product.TotalValue -%}
{% endif -%}

{% include 'partials/common/date-format.html' -%}

{% if config.Complaints.ComplaintsEnabled or config.Complaints.ReturnsEnabled -%}
	{% assign complaintsOrReturnsEnabled = true -%}
{% endif -%}

<td class="id">
	{{ product.No }}
</td>

<td>
	{% if product.Url -%}
		<div tabindex="0" class="product-cell replace-url-js" data-url="{{ page.BaseHref }}{{ product.Url }}" style="cursor: pointer;">
  	{% endif -%}
			<div class="image">
		    	{% if product.ImageId != -1 or product.Image != null -%} {{ product | Img: 'thumb' }} {% else -%} <svg width="40" height="40"><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use></svg> {% endif -%}
		  	</div>
		  	<div class="product-info">
				<span class="product-name">
			  		{{ product.NameNoHtml }}
				</span>
			  	{% if config.Products.ShowCode -%}
			  		<span class="product-code">
				  		{{product.Code}}
				  	</span>
				{% endif -%}

				{% if product.Description != "" or product.Weight > 0 or product.Status.Text -%}
					<div {% unless product.Description == "" -%} class="expandable-js" {% endunless -%}>
						{% if product.Description != "" -%}
							<ul class="description">
								{% assign descriptionLength = product.Description | Size | Minus: 2 -%}
								{% assign description = product.Description | Slice: 0, descriptionLength | Split: ';' -%}
								{% for attribute in description -%}
									<li>
										{{ attribute }}
									</li>
								{% endfor -%}
							</ul>
						{% endif -%}
						{% if product.Weight > 0 -%}
							<div class="description">
								{{ translations.Weight }}: {{ product.Weight | Normalize }} {{ translations.Kg }}
							</div>
						{% endif -%}
						{% unless settings.showAvailabilityStatus == 'no' and product.Status.Status == 1 -%}
							{% if product.Status.Text -%}
								<div class="description">
									{{ translations.Availability }}: {{ product.Status.Text }} {% if product.Status.Date != null -%}(<time>{{ product.Status.Date | Date:dateFormat }}</time>){% endif -%}
								</div>
							{% endif -%}
						{% endunless -%}
					</div>
				{% endif -%}
		  	</div>
	{% if product.Url -%}
		</div>
	{% endif -%}
</td>

{% if page.PageId == config.DefinedPages.Order.Id -%}
	{% assign attributes = config.Orders.AttributesCart.Position -%}
	{% assign positionAttrSize = attributes | Size -%}
	{% assign showInCart = true -%}
	{% assign action = 'Cart/AttributesSet' -%}
{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id and order.EditingAllowed -%}
	{% assign attributes = config.Orders.AttributesEdit.Position -%}
	{% assign showInCustomerProfile = true -%}
	{% assign action = 'OrderEdit/PositionAttributesSet' -%}
	{% assign positionAttrSize = attributes | Size -%}
	{% assign allProducts = order.Products | Size -%}
	{% assign nullAttributes = '' -%}
	{% for positionAttr in attributes -%}
		{% assign intId = positionAttr.Id | ToInt -%}
		{% assign nullProducts = 0 -%}
		{% for tableProduct in order.Products -%}
			{% if positionAttr.Editable == false and tableProduct.Attributes[intId].Value == null -%}
				{% assign nullProducts = nullProducts | Plus:1 -%}
			{% endif -%}
		{% endfor -%}
		{% if nullProducts == allProducts -%}
			{% assign positionAttrSize = positionAttrSize | Minus:1 -%}
			{% assign idString = positionAttr.Id | ToString -%}
			{% assign nullAttributes = nullAttributes | Append:idString | Append:'|' -%}
		{% endif -%}
  	{% endfor -%}
  	{% if nullAttributes != '' -%}
		{% assign nullAttributes = nullAttributes | Split:'|' -%}
  	{% endif -%}
{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id and order.EditingAllowed == false -%}
	{% unless page.QueryString contains 'tab=inquiry-details' -%}
		{% assign attributes = product.Attributes -%}
		{% assign profileNotEditing = true -%}
		{% assign positionAttrSize = attributes | Size -%}
		{% assign ids = '' -%}
		{% for tableProduct in order.Products -%}
			{% for positionAttr in tableProduct.Attributes -%}
				{% assign idString = positionAttr.Id | ToString -%}
				{% if ids == '' -%}
					{% assign ids = ids | Append:idString -%}
				{% else -%}
					{% assign inArr = false -%}
					{% assign ids = ids | Split:'|' -%}
					{% for id in ids -%}
						{% if id == idString -%}
							{% assign inArr = true -%}
							{% break -%}
						{% endif -%}
					{% endfor -%}
					{% assign ids = ids | Join:'|' -%}
					{% if inArr == false -%}
						{% assign ids = ids | Append:'|' | Append:idString -%}
					{% endif -%}
				{% endif -%}
			{% endfor -%}
		{% endfor -%}
		{% if ids != '' -%}
			{% assign attributes = ids | Split:'|' -%}
			{% assign positionAttrSize = attributes | Size -%}
			{% assign allProducts = order.Products | Size -%}
			{% assign nullAttributes = '' -%}
			{% for positionAttr in attributes -%}
				{% assign intId = positionAttr | ToInt -%}
				{% assign nullProducts = 0 -%}
				{% for tableProduct in order.Products -%}
					{% if tableProduct.Attributes[intId].Value == null or tableProduct.Attributes[intId].Value == '' -%}
						{% assign nullProducts = nullProducts | Plus:1 -%}
					{% endif -%}
				{% endfor -%}
				{% if nullProducts == allProducts -%}
					{% assign positionAttrSize = positionAttrSize | Minus:1 -%}
					{% assign idString = positionAttr | ToString -%}
					{% assign nullAttributes = nullAttributes | Append:'|' | Append:idString -%}
				{% endif -%}
			{% endfor -%}
			{% if nullAttributes != '' -%}
				{% assign nullAttributes = nullAttributes | Split:'|' -%}
			{% endif -%}
		{% endif -%}
	{% endunless -%}
{% endif -%}

{% unless page.QueryString contains 'tab=inquiry-details' -%}
	<td class="prices-view-js">
		{% if price > 0 -%}
			<span>{{ price | ToPrice }}</span>
			{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit -%}
				<small class="prices unit-ratio-info-js">
					{{ price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
				</small>
			{% endif -%}
		{% else -%}
			<span>{{translations.Free}}</span>
		{% endif -%}
	</td>
{% endunless -%}

{% if config.ENTERPRISE -%}
	{% unless customer.Cart.Inquiry -%}
		{% unless page.QueryString contains 'tab=inquiry-details' -%}
			<td class="prices-view-js">
				{% if totalPrice > 0 -%}
					{{ totalPrice | ToPrice }}
					{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit -%}
						<small class="prices unit-ratio-info-js">
							{{ totalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
						</small>
					{% endif -%}
				{% endif -%}
			</td>
		{% endunless -%}
	{% endunless -%}
{% endif -%}

{% unless customer.Cart.Inquiry -%}
	{% unless page.QueryString contains 'tab=inquiry-details' -%}
		<td class="prices-view-js">
			{{ product.VAT}} %
		</td>
	{% endunless -%}
{% endunless -%}

{% if page.QueryString contains 'tab=offer-details' -%}
	{% assign DepositValue = product.DepositValue -%}
{% else -%}
	{% assign DepositValue = product.TotalDepositValue -%}
{% endif -%}

{% unless page.QueryString contains 'tab=inquiry-details' -%}
	{% if order.TotalDepositValue > 0 -%}
		{% if DepositValue > 0 -%}
			<td>
				{{ DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ product.CurrencyExt }}
			</td>
		{% else -%}
			<td>
				0,00 {{ product.CurrencyExt }}
			</td>
		{% endif -%}
	{% endif -%}
{% endunless -%}

{% assign isStepper = false -%}

{% if order.OrderStep == 'Start' and product.CanChangeQuantity -%}
	{% assign isStepper = true -%}
{% endif -%}

{% if order.EditingAllowed and product.IsDeleted == false -%}
	{% assign isStepper = true -%}
{% endif -%}

	{% if isStepper -%}
		{% unless page.QueryString contains 'tab=inquiry-details' -%}
			<td class="prices-view-js">
				<div class="form-js no-message-js change-quantity-in-cart-js">
				{% unless order.EditingAllowed -%}
					<input type="hidden" name="__action" value="Cart/QuantityChange">
					<input type="hidden" name="no" value="{{ product.No }}">
				{% endunless -%}
					{% assign unitName = '' -%}
					{% include 'partials/product/amount-stepper.html' with product -%}

					<span>
						{% if product.SaleUnit -%}
							{{product.SaleUnit}}
						{% else -%}
							{{product.Unit}}
						{% endif -%}
					</span>

					<div>
						<div class="validation-info-js validation-required-js hidden-js">
						{{ translations.FillQuantity }}
						</div>
						<div class="validation-info-js validation-quantity-range-js hidden-js">
						{{ translations.FillProperQuantityRange }} 99999
						</div>
					{% if unitMultiplicity > 0 -%}
						{% if page.PageId == config.DefinedPages.Order.Id or page.PageId == config.DefinedPages.CustomerProfile.Id -%}
						<div class="multiplicity-info-js">{{ translations.Multiplicity }} <span class="multiplicity-js">{{ unitMultiplicity }}</span> <span class="name-js">{{ unitName }}</span></div>
						{% endif -%}
					{% endif -%}
					</div>
				</div>
			</td>
		{% endunless -%}
	{% else -%}
		<td class="prices-view-js">
			<span>
				{% if config.Products.DecimalUnits -%}
					{{product.Quantity}}
				{% else -%}
					{{product.Quantity | Normalize }}
				{% endif -%}
			</span>
			<span>
				{% if product.IsSetElement -%}
					{% if page.PageId == config.DefinedPages.CustomerProfile.Id -%}
						{{product.Unit}}
					{% else -%}
						{{product.SaleUnit}}
					{% endif -%}
				{% elseif page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' -%}
						{{product.SaleUnit}}
					{% elseif page.PageId == config.DefinedPages.CustomerProfile.Id -%}
						{{product.Unit}}
				{% endif -%}
			</span>
			{% if settings.showUnitRateOnCartPage == 'yes' and product.BasicUnit != null and product.BasicUnit != product.SaleUnit %}
				<small class="prices unit-ratio-info-js">
					1 {{product.SaleUnit}} = {{product.BasicUnitRatio | Round: 4}} {{product.BasicUnit}}
				</small>
			{% endif -%}
		</td>
	{% endif -%}

{% unless customer.Cart.Inquiry -%}
	{% if isDiscount -%}
		<td class="prices-view-js">
			{% unless page.QueryString contains 'tab=inquiry-details' -%}
				{% if product.Discount == 0 -%}
					0,00 %
				{% else -%}
					{% if priceBefore != 0 and productValue != 0 -%}
						{% if product.Discount != 0 -%}
							{{product.Discount}} %
						{% endif -%}
					{% endif -%}
					{% if productValue == 0 -%}
						100 %
					{% endif -%}
				{% endif -%}
			{% endunless -%}
		</td>
	{% endif -%}
{% endunless -%}

{% unless page.QueryString contains 'tab=inquiry-details' -%}
	<td class="prices-view-js">
		{% if productValue > 0 -%}
			<span>{{ productValue | ToPrice }}</span>
		{% endif -%}
	</td>
{% endunless -%}


{% if config.ENTERPRISE -%}
		{% unless page.QueryString contains 'tab=inquiry-details' -%}
		<td class="prices-view-js">
			{% if totalValue > 0 -%}
				{{ totalValue | ToPrice}}
			{% endif -%}
		</td>
		{% endunless -%}
{% endif -%}

	{% unless page.QueryString contains 'tab=inquiry-details' -%}
	<td class="prices-view-js">
		{{ order.CurrencyExt }}
	</td>
	{% endunless -%}

<td class="options">
{% if page.PageId == config.DefinedPages.CustomerProfile.Id -%}
	{% unless product.Description == "" -%}
	<button class="pure-button expand-data-js change-arrow-title-js dropdown-arrow" title="{{ translations.ShowDetails }}">
		<svg height="16" width="16" class="icon rotate-down">
			<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
		</svg>
	</button>
	{% endunless -%}
{% else -%}
	{% unless product.Description == "" and product.Weight <= 0 and product.Status.Text == null -%}
	<button class="pure-button expand-data-js change-arrow-title-js dropdown-arrow" title="{{ translations.ShowDetails }}">
		<svg height="16" width="16" class="icon rotate-down">
			<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
		</svg>
	</button>
	{% endunless -%}
{% endif -%}
</td>
<td class="options complaint-actions-inline">
	{% if order.Status == 3 and complaintsOrReturnsEnabled -%}
		{% if config.Complaints.ComplaintsEnabled == true and product.CanComplain == true -%}
			<button class="pure-button open-complaint-form-js complaint-action-btn" data-type="complaint" data-product="{{ product.Url }}">
				{{ translations.Complain }}
			</button>
		{% endif -%}
		{% if config.Complaints.ReturnsEnabled == true and product.CanReturn == true and product.IsSetElement == false -%}
			<button class="pure-button open-complaint-form-js complaint-action-btn" data-type="return" data-product="{{ product.Url }}">
				{{ translations.Return }}
			</button>
		{% endif -%}
	{% endif -%}
</td>
{% if order.Status == 3 and complaintsOrReturnsEnabled -%}
	{% if config.Complaints.ComplaintsEnabled == true and product.CanComplain == true -%}
		<div class="opening-modal-js complaint-form-js" data-type="complaint" data-product="{{ product.Url }}">
			{% include 'partials/customer-profile/complaints/complaint-form.html' with 'complaint' -%}
		</div>
	{% endif -%}
	{% if config.Complaints.ReturnsEnabled == true and product.CanReturn == true and product.IsSetElement == false -%}
		<div class="opening-modal-js complaint-form-js" data-type="return" data-product="{{ product.Url }}">
			{% include 'partials/customer-profile/complaints/complaint-form.html' with 'return' -%}
		</div>
	{% endif -%}
{% endif -%}
`